import React       from 'react';
import fontawesome from '@fortawesome/fontawesome';

import ProjectBanner     from './components/ProjectBanner';
import ProjectItems      from './components/ProjectItems'
import ProjectSummary    from './components/ProjectSummary';

fontawesome.config = {
  autoReplaceSvg: true,
};

export default () => {
  if (!bundle_items || !bundle_items.length) {
    console.error('No bundle items configured');
    return null
  }

  return (
    <>
      <ProjectBanner />
      <ProjectSummary />
      <ProjectItems />
    </>
  )
}
